module.exports = __webpack_public_path__ + "img/bust-in-silhouette.png";